module.exports = __webpack_public_path__ + "img/Carousel-Beneficios-icono-05.b4d2d110.svg";